module.exports = __webpack_public_path__ + "static/media/people.2ff5ca6e.svg";